/** t268u: the one short label for the report entry (sidebar, collapsed rail tooltip, your-name menu, Me, Help, the dialog). */
export const REPORT_LABEL = 'Report Bug / Suggest Feature';
